export function onboardingHelper() {
    return {
        startIntro(intro, context, localStorageItem) {
            let nextLabel = context.userRole !== 'Teacher' && 
                context.$route.name === 'dashboard'
                    ? 'NO, THANKS'
                    : 'NEXT'
            if (context.userRole !== 'Teacher' && context.$route.name === 'dashboard') {
                const averageButton = document.getElementsByClassName('el-radio-group')[0]
                                                .firstChild
                                                .firstChild
                intro.onchange(() => {
                    if (averageButton.classList.value.indexOf('is-active') === -1) {
                        averageButton.click()
                    }
                })
            }
            intro.setOptions({
                steps: context.steps,
                'nextLabel': nextLabel,
                'prevLabel': 'BACK',
                'skipLabel': 'SKIP',
                'doneLabel': 'DONE',
                'hidePrev': true,
                'hideNext': true,
                'showStepNumbers': false
            }).onchange((targetElement) => {
                if (nextLabel === 'NO, THANKS' && 
                    document.querySelector('a.introjs-nextbutton')) {
                    if (targetElement.id !== 'school-option') {
                        document.querySelector('a.introjs-nextbutton').innerHTML = 'NEXT'
                    } else {    
                        document.querySelector('a.introjs-nextbutton').innerHTML = 'NO, THANKS'
                    }
                }
            }).goToStep(1).start().onexit(() => {
                if (!localStorage.getItem(localStorageItem)) {
                    localStorage.setItem(localStorageItem, true)
                }
            })
        },
        closeIconText(localStorageItem) {
            return `<i class="el-icon-close" onclick="
                document.getElementsByClassName('introjs-overlay')[0].style.display = 'none';
                document.getElementsByClassName('introjs-helperLayer')[0].style.display = 'none';
                document.getElementsByClassName('introjs-tooltipReferenceLayer')[0].style.display = 'none';
                if (!localStorage.getItem('${localStorageItem}')) { 
                    localStorage.setItem('${localStorageItem}', true) 
                }
            "></i>`
        }
    }
}